import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = { class: "question-filter-head" }
const _hoisted_3 = { class: "mr-5 w-33-pr" }
const _hoisted_4 = { class: "mr-5 w-33-pr" }
const _hoisted_5 = { class: "mr-5 w-33-pr" }
const _hoisted_6 = { class: "question-activity" }
const _hoisted_7 = { class: "log-item-wrapper" }
const _hoisted_8 = { class: "log-item" }
const _hoisted_9 = { class: "log-item-title" }
const _hoisted_10 = { class: "details-button" }
const _hoisted_11 = { class: "detail-tooltip" }
const _hoisted_12 = { class: "log-item-date" }
const _hoisted_13 = { class: "person" }
const _hoisted_14 = { class: "log-diff-wrapper" }
const _hoisted_15 = { class: "info-row" }
const _hoisted_16 = { class: "action-value" }
const _hoisted_17 = { class: "info-row" }
const _hoisted_18 = { class: "current-value" }
const _hoisted_19 = { class: "info-row" }
const _hoisted_20 = { class: "previous-value" }
const _hoisted_21 = {
  key: 0,
  class: "pagination-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_gray_text = _resolveComponent("gray-text")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_select_input, {
          value: _ctx.filteredUserId,
          options: _ctx.userListOption,
          placeholder: "Select User",
          onHandleChange: _ctx.onSelectFilteredUser
        }, null, 8, ["value", "options", "onHandleChange"])
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_select_input, {
          value: _ctx.filteredQuestionId,
          options: _ctx.questionListOption,
          placeholder: "Select Question",
          onHandleChange: _ctx.onSelectFilteredQuestion
        }, null, 8, ["value", "options", "onHandleChange"])
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_date_picker, {
          "apply-button-label": "Apply",
          "date-input": _ctx.fromToData.dateInput,
          format: _ctx.fromToData.format,
          "same-date-format": _ctx.fromToData.sameDateFormat,
          "show-helper-buttons": true,
          inline: false,
          "switch-button-initial": true,
          onDateApplied: _ctx.onFilterByDates,
          onOnReset: _ctx.onFilterByDates
        }, null, 8, ["date-input", "format", "same-date-format", "onDateApplied", "onOnReset"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        (_ctx.activityList.length === 0)
          ? (_openBlock(), _createBlock(_component_gray_text, { key: 0 }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("No Activity yet", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityList, (log) => {
          return (_openBlock(), _createElementBlock("div", {
            key: log.id
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("b", null, _toDisplayString(log.question.text), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Details ", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatInTimeZone(new Date(log.created_at), Intl.DateTimeFormat().resolvedOptions().timeZone, ' MMM d, yyyy')) + " at " + _toDisplayString(_ctx.formatInTimeZone(new Date(log.created_at), Intl.DateTimeFormat().resolvedOptions().timeZone, ' hh:mmaa')) + " " + _toDisplayString(_ctx.tzAbbreviation), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(log.user.name ? `by ${log.user.name}` : 'by -'), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOldNewMap(log), (message) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "log-diff",
                    key: message.oldValue + message.oldValue + message.action
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "w-100-px" }, "ACTION:", -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(message.action), 1)
                    ]),
                    _createElementVNode("span", _hoisted_17, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "w-100-px" }, "CURRENT:", -1)),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(message.newValue), 1)
                    ]),
                    _createElementVNode("span", _hoisted_19, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "w-100-px" }, "PREVIOUS:", -1)),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(message.oldValue), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ]),
      (_ctx.pagination && _ctx.pagination.last_page !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(_component_pagination, {
              "current-page": _ctx.pagination.current_page,
              "total-pages": _ctx.pagination.total,
              meta: _ctx.pagination,
              label: "activities",
              onHandleClick: _ctx.navigateToPage
            }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}